"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var banali_react_leaflet_1 = require("banali-react-leaflet");
var Choropleth_1 = __importDefault(require("./Choropleth"));
var react_redux_1 = require("react-redux");
var mapSlice_1 = require("../../../features/google/mapSlice");
var deviceHelper_1 = require("../../../helpers/deviceHelper");
var i18n_1 = __importDefault(require("../../../i18n"));
var Localization_1 = require("../../../constants/Localization");
var googleMapUtilit_1 = require("../../../components/googleOverlay/googleMapUtilit");
var PostCard_1 = __importDefault(require("../../../components/PostCard/PostCard"));
var GeneralSettings_1 = require("../../../constants/GeneralSettings");
var PostLayout_1 = require("../../../types/PostLayout");
// import Markers from './Markers';
var GoogleGeocoding_1 = __importDefault(require("../../../constants/GoogleGeocoding"));
var languageSlice_1 = require("../../../features/languages/languageSlice");
var Cluster_1 = __importDefault(require("./Cluster"));
var useTileLayer_1 = require("../../../hooks/useTileLayer");
var Map = function (_a) {
    var state = _a.state, onStateChange = _a.onStateChange, stateQuery = _a.stateQuery, setIsSelectedMarker = _a.setIsSelectedMarker, handleOpenPostPreviewBySlug = _a.handleOpenPostPreviewBySlug, additionalQuery = _a.additionalQuery, query = _a.query, locationPathName = _a.locationPathName, onAddBookmark = _a.onAddBookmark, onRemoveBookmark = _a.onRemoveBookmark, setMapQuery = _a.setMapQuery, stateFilterIsSelected = _a.stateFilterIsSelected, filterAreRemoved = _a.filterAreRemoved, isAddressPickerSelected = _a.isAddressPickerSelected, public_code = _a.public_code, isPostCardClicked = _a.isPostCardClicked;
    var dispatch = react_redux_1.useDispatch();
    var mapRef = react_1.useRef(null);
    var markers = react_redux_1.useSelector(mapSlice_1.googleMarkers);
    var currentLanguage = react_redux_1.useSelector(languageSlice_1.selectCurrentLanguage);
    var _b = react_1.useState(null), selectedMarker = _b[0], setSelectedMarker = _b[1];
    var tileLayer = useTileLayer_1.useTileLayer(currentLanguage);
    var polygonData = react_1.useMemo(function () {
        return state.map(function (item) {
            return item.geometry.coordinates.map(function (item) {
                return item.map(function (item) { return [item[1], item[0]]; });
            })[0];
        });
    }, [state]);
    react_1.useEffect(function () {
        setIsSelectedMarker(!!selectedMarker);
    }, [selectedMarker]);
    react_1.useEffect(function () {
        var filters = __assign(__assign(__assign({ public_code: public_code }, query), stateQuery), { deal: Localization_1.PagePrefix[locationPathName] });
        if (stateQuery.state) {
            filters.state_id = stateQuery.state;
            delete filters.state;
        }
        if (stateQuery.district) {
            filters.district_id = stateQuery.district;
            delete filters.district;
        }
        var delayDebounceFn;
        if (!isPostCardClicked) {
            delayDebounceFn = setTimeout(function () {
                dispatch(mapSlice_1.getMapPostsResultByViewBox({
                    filters: filters,
                    viewBox: googleMapUtilit_1.getViewBoxVertices(additionalQuery.viewBox),
                }));
            }, 1500);
        }
        return function () { return clearTimeout(delayDebounceFn); };
    }, [
        public_code,
        query,
        stateQuery,
        additionalQuery.viewBox,
        locationPathName,
        isPostCardClicked,
    ]);
    var onMarkerSelect = function (marker) {
        if (!deviceHelper_1.isMobile()) {
            handleOpenPostPreviewBySlug(marker.slug[i18n_1.default.language]);
        }
        else {
            setSelectedMarker(marker);
        }
    };
    var onToggleBookMark = function (callBackAction, bookmarked) {
        callBackAction(selectedMarker.id);
        setSelectedMarker(function (prevState) { return (__assign(__assign({}, prevState), { bookmarked: !bookmarked })); });
    };
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(banali_react_leaflet_1.MapContainer, { ref: mapRef, style: { height: '100%', zIndex: '0' }, zoomControl: false, attributionControl: false },
            react_1.default.createElement(banali_react_leaflet_1.TileLayer, { url: tileLayer, minZoom: 8 }),
            react_1.default.createElement(Choropleth_1.default, { state: state, stateQuery: stateQuery, additionalQuery: additionalQuery, stateFilterIsSelected: stateFilterIsSelected, query: query, filterAreRemoved: filterAreRemoved, isAddressPickerSelected: isAddressPickerSelected, setMapQuery: setMapQuery }), polygonData === null || polygonData === void 0 ? void 0 :
            polygonData.map(function (poly, index) { return (react_1.default.createElement(banali_react_leaflet_1.Polygon, { key: index, pathOptions: {
                    color: '#0D8272',
                    fillColor: stateQuery.state.includes(String(state[index].govId))
                        ? 'lightblue'
                        : '#0D8272',
                    item: state[index],
                }, positions: poly, eventHandlers: {
                    click: function (e) {
                        if (e.target._map.getZoom() <=
                            GoogleGeocoding_1.default.MAP.NO_CLICKABLE_ZOOM) {
                            e.target.setStyle({
                                weight: 4,
                                fillColor: 'lightblue',
                            });
                            onStateChange(e.target.options.item.govId);
                            setSelectedMarker(null);
                        }
                    },
                } })); }),
            react_1.default.createElement(Cluster_1.default, { mapRef: mapRef, markers: markers, onMarkerSelect: onMarkerSelect }),
            deviceHelper_1.isMobile() && (react_1.default.createElement(banali_react_leaflet_1.ZoomControl, { position: "bottomright", zoomInText: "+", zoomOutText: "-" }))),
        selectedMarker && deviceHelper_1.isMobile() && (react_1.default.createElement("div", { className: "mobile-selected-marker" },
            react_1.default.createElement(PostCard_1.default, { post: selectedMarker, openPostPreview: function () {
                    return handleOpenPostPreviewBySlug(selectedMarker.slug[i18n_1.default.language]);
                }, onAddBookmark: function () {
                    return onToggleBookMark(onAddBookmark, selectedMarker.bookmarked);
                }, onRemoveBookmark: function () {
                    return onToggleBookMark(onRemoveBookmark, selectedMarker.bookmarked);
                }, previewUrl: GeneralSettings_1.PREVIEW_URL.preview, displayType: PostLayout_1.PostLayout.SEARCH })))));
};
exports.default = Map;
